export default {"src":"/login-app/[GIT_HASH]/_next/static/media/asset_legacy.8b361672.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};